'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { useEffect, useState } from 'react'

import SubmitButton from '@/components/Form/Atoms/SubmitButton'
import ProductInfoFormLogic from '@/components/Form/Organisms/ProductInfoForm/ProductInfoFormLogic'
import { AnimationChildrenProps } from '@/components/LandingPage/ContentModel/Animation'
import ProductCard from '@/components/Product/ProductCard'
import ProductCardLink from '@/components/Product/ProductCardLink'
import Products from '@/components/Product/Products'
import { getProducts } from '@/serverActions/getProducts'
import { ContentModelProductCardsType } from '@/types/ContentModel/ContentModelProductCards'
import { ProductType } from '@/types/product'

export default function ProductCards({
  contentModel,
}: {
  contentModel: ContentModelProductCardsType
} & AnimationChildrenProps) {
  const pathname = usePathname()
  const [products, setProducts] = useState<ProductType[]>([])

  useEffect(() => {
    getProducts({}).then((products) => {
      setProducts(products)
    })
  }, [pathname])

  return contentModel.carousel ? (
    products.length > 0 ? (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          overflowY: 'scroll',
        }}
      >
        {products
          .filter((product) => product.purchasable)
          .map((product, index) => {
            return (
              <div
                key={product.productId}
                style={{
                  flex: 'none',
                  backgroundColor: '#f9f7f4',
                  width: '60%',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <div
                  style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    borderRight: '1px solid rgba(6, 7, 37, 0.1)',
                    borderTop: '1px solid rgba(6, 7, 37, 0.1)',
                    borderBottom: '1px solid rgba(6, 7, 37, 0.1)',
                    ...(index === 0 ? { borderLeft: '1px solid rgba(6, 7, 37, 0.1)' } : {}),
                  }}
                >
                  <ProductCardLink product={product}>
                    <ProductCard product={product} />
                  </ProductCardLink>
                </div>

                <ProductInfoFormLogic product={product}>
                  <div
                    style={{
                      padding: '2rem',
                    }}
                  >
                    <Link
                      href={`/products/${product.productId}`}
                      style={{
                        textDecoration: 'underline',
                        color: 'black',
                        display: 'block',
                        marginBottom: '2rem',
                        fontSize: '1.2rem',
                        textAlign: 'center',
                      }}
                    >
                      詳細を見る
                    </Link>

                    <SubmitButton width={'100%'} allowDirty={true}>
                      カートに追加
                    </SubmitButton>
                  </div>
                </ProductInfoFormLogic>
              </div>
            )
          })}
      </div>
    ) : (
      <></>
    )
  ) : (
    <Products
      nextLink={false}
      groupSymbol={null}
      productIds={(contentModel as ContentModelProductCardsType).productIds}
    >
      {(product) => <ProductCard product={product} />}
    </Products>
  )
}
